import React from "react";

function IconShell({ className, viewBox = "0 0 20 20", children }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

export function IconAdminPanel({ className }) {
  return (
    <IconShell className={className}>
      <path
        fill="currentColor"
        d="M10 1.75 4 4.35v5.15c0 3.02 2.42 5.85 6 7.35 3.58-1.5 6-4.33 6-7.35V4.35L10 1.75Zm0 1.86 4.75 2.06v4.48c0 2.14-1.62 4.27-4.75 5.58-3.13-1.31-4.75-3.44-4.75-5.58V5.67L10 3.61ZM10 7.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Z"
      />
    </IconShell>
  );
}

export function IconPersonalHangar({ className }) {
  return (
    <span
      className={["tooltip-link__icon", "tooltip-link__icon--hangar", className]
        .filter(Boolean)
        .join(" ")}
      aria-hidden="true"
    />
  );
}

export function IconUserSettings({ className }) {
  return (
    <IconShell className={className} viewBox="0 0 16 16">
      <path
        fill="currentColor"
        d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z"
      />
      <path
        fill="currentColor"
        d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z"
      />
    </IconShell>
  );
}

export function IconOnboarding({ className }) {
  return (
    <IconShell className={className}>
      <path
        fill="currentColor"
        d="M10 3.25a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5ZM4.5 12.625A2.375 2.375 0 0 0 2.125 15v.625a.625.625 0 0 0 .625.625h14.5a.625.625 0 0 0 .625-.625V15a2.375 2.375 0 0 0-2.375-2.375H4.5Z"
      />
    </IconShell>
  );
}

export function IconLogout({ className }) {
  return (
    <IconShell className={className}>
      <path
        fill="currentColor"
        d="M7.25 3.75A1.75 1.75 0 0 0 5.5 5.5v9A1.75 1.75 0 0 0 7.25 16.25H9a.75.75 0 0 0 0-1.5H7.25a.25.25 0 0 1-.25-.25v-9c0-.138.112-.25.25-.25H9a.75.75 0 0 0 0-1.5H7.25Zm4.97 2.72a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06l-3.25 3.25a.75.75 0 1 1-1.06-1.06l1.72-1.72H10a.75.75 0 0 1 0-1.5h3.94l-1.72-1.72a.75.75 0 0 1 0-1.06Z"
      />
    </IconShell>
  );
}
